import React, { Fragment, useRef } from "react";
import { Card, CardBody, CardHeader, Col, Container, Table, Row, Label, Modal, ModalHeader, ModalBody, ModalFooter, Collapse } from 'reactstrap';

import { api } from "../utils/index";
import CardLoader from "./CardLoader";
import MyDateRenderer from "./MyDateRenderer";
import HtmlToPdfButton from "./HtmlToPdfButton";
import FormProductChecklistSASO from "./FormProductChecklistSASO"
import logoLight from "../assets/images/logo192.png";

const FormReviewSASO = (props) => {
    const divPrintRef = useRef(null);

    const [reviewFormCollapsed, setReviewFormCollapsed] = React.useState(true);
    const [generatingPdf, setGeneratingPdf] = React.useState(false);
    const [formVersion, setFormVersion] = React.useState(props.formTemplate ? props.formTemplate.version : 1);
    
    React.useEffect(() => {
        if(props.formTemplate) {
            setFormVersion(props.formTemplate.version)
        }
    }, [props.formTemplate]);

    const getVersionName = () => {
        if(props.formTemplate) {
            return props.formTemplate.versionName;
        }

        return "";
    }

    const isTableEditable = () => {
        if(generatingPdf || (props.fboState && props.fboState.canEditForm1)) {
            return true;
        }

        return false;
    }

    return(
        <Card className="card-secondary mb-3">
            <CardHeader className="border-0 d-flex align-items-center">
                <CardLoader loading={props.loading || generatingPdf} />
                <h5 className="card-title mb-0 flex-grow-1 cursor-pointer" onClick={() => setReviewFormCollapsed(!reviewFormCollapsed)}>
                    {reviewFormCollapsed && <i className="ri-add-box-line align-bottom text-primary"></i>}
                    {!reviewFormCollapsed && <i className="ri-checkbox-indeterminate-line align-bottom text-primary"></i>}
                    Application Review Form ({reviewFormCollapsed ? "Expand" : "Collapse"})
                </h5>
                
            </CardHeader>
            <CardBody className="border border-dashed border-end-0 border-start-0">
                <Collapse isOpen={!reviewFormCollapsed} className="collapse">
                    <Row className="gy-2" style={{backgroundColor:"white"}}>
                        <Col>
                            <HtmlToPdfButton
                                setGeneratingPdf={setGeneratingPdf}
                                fileName={props.fboState.ticket.requestNumber + " Application Review Form.pdf"}
                                divPrintRef={divPrintRef}
                            />
                        </Col>
                        <div className={`col-md-12 col-xxl-12 ${generatingPdf ? "table-form-print" : ""}`} ref={divPrintRef}>
                            {generatingPdf &&
                            <Fragment>
                                <table className="table-form">
                                    <tbody>
                                        <tr>
                                            <td style={{textAlign:"left", border: "none", backgroundColor: "white", verticalAlign: "bottom"}}><h5><b>Application Review Form - SASO</b></h5></td>
                                            <td style={{textAlign:"right", border: "none", backgroundColor: "white"}}><img src={logoLight} alt="" height="100" /></td>
                                        </tr>
                                    </tbody>
                                </table>
                                <table className={`table-form ${isTableEditable() ? "" : "table-form-readonly"}`}>
                                    <tbody>
                                        <tr>
                                            <td style={{width:"25%"}}>Request Number over SABER</td>
                                            <td colSpan={3}>{(props.fboState && props.fboState.ticket && props.fboState.ticket.sasoRequestNumber) || ""}&nbsp;</td>
                                        </tr>
                                        <tr>
                                            <td>Commercial Registration (CR) No</td>
                                            <td colSpan={3}>{(props.customer && props.customer.length > 0 && props.customer[0].commercialRegistrationNumber) || ""}&nbsp;</td>
                                        </tr>
                                        <tr>
                                            <td>Client Name</td>
                                            <td colSpan={3}>{(props.customer && props.customer.length > 0 && props.customer[0].organizationName) || ""}&nbsp;</td>
                                        </tr>
                                        <tr>
                                            <td>Manufacturer Name</td>
                                            <td colSpan={3}>{(props.manufacturer && props.manufacturer.length > 0 && props.manufacturer[0].organizationName) || ""}&nbsp;</td>
                                        </tr>
                                        <tr>
                                            <td>Technical Regulation</td>
                                            <td colSpan={3}>{(props.fboState && props.fboState.ticket && props.fboState.ticket.technicalRegulation) || ""}&nbsp;</td>
                                        </tr>
                                        <tr>
                                            <td>Please select Type</td>
                                            <td style={{width:"25%"}}>
                                                <input type="radio" readOnly={true} checked={(props.fboState && props.fboState.ticket.requestSubType === "Type 1a")} /> Type 1a
                                            </td>
                                            <td style={{width:"25%"}}>
                                                <input type="radio" readOnly={true} checked={(props.fboState && props.fboState.ticket.requestSubType === "Type 3")} /> Type 3
                                            </td>
                                            <td style={{width:"25%"}}>
                                                <input type="radio" readOnly={true} checked={(props.fboState && props.fboState.ticket.requestSubType === "Type 5")} /> Type 5<sup>1</sup>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Date of Request</td>
                                            <td>
                                                <MyDateRenderer value={(props.fboState && props.fboState.ticket && props.fboState.ticket.dateAdded) || ""} format={"dd.mm.yyyy"} />&nbsp;
                                            </td>
                                            <td>Request Region</td>
                                            <td>{(props.fboState && props.fboState.ticket.region) || ""}&nbsp;</td>
                                        </tr>
                                        <tr>
                                            <td>Request Type</td>
                                            <td>
                                                <input type="radio" readOnly={true} checked={(props.fboState && props.fboState.ticket.certificateType === "New")} /> New
                                            </td>
                                            <td colSpan={2}>
                                                <input type="radio" readOnly={true} checked={(props.fboState && props.fboState.ticket.certificateType === "Renewal")} /> Renewal, Please refer old certificate number<sup>2</sup>. {(props.fboState && props.fboState.ticket.oldCertificateNumber) || ""}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </Fragment>
                            }
                            <table className={`table-form ${isTableEditable() ? "" : "table-form-readonly"}`}>
                                <thead>
                                    <tr>
                                        <td style={{textAlign:"center", border: "none", backgroundColor: "white"}}><h5><b>Application Review<sup>3</sup></b></h5></td>
                                    </tr>
                                </thead>
                            </table>
                            {generatingPdf &&
                            <FormProductChecklistSASO
                                generatingPdf={generatingPdf}
                                loading={props.loading}
                                fboState={props.fboState}
                                customer={props.selectedCustomer}
                                manufacturer={props.selectedManufacturer}
                                formTemplate={props.fboState && props.fboState.productChecklistForm && props.fboState.productChecklistForm.formTemplate ? props.fboState.productChecklistForm.formTemplate : null}
                                isValidFieldValue={props.isValidFieldValue}
                                getFieldValue={props.getFieldValue}
                                getFieldValueText={props.getFieldValueText}
                                getFieldValueDate={props.getFieldValueDate}
                                setFieldValue={props.setFieldValue}
                                setFieldValueText={props.setFieldValueText}
                                setFieldValueDate={props.setFieldValueDate}
                                setFieldValueNumber={props.setFieldValueNumber}
                            />
                            }
                            <table className={`table-form ${isTableEditable() ? "" : "table-form-readonly"}`}>
                                <thead className="header">
                                    <tr>
                                        <td style={{width:"5%", border:"none", padding: "0"}}></td>
                                        <td style={{width:"65%", border:"none", padding: "0"}}></td>
                                        <td style={{width:"10%", border:"none", padding: "0"}}></td>
                                        <td style={{width:"10%", border:"none", padding: "0"}}></td>
                                        <td style={{width:"10%", border:"none", padding: "0"}}></td>
                                    </tr>
                                    <tr>
                                        <td className="index-col">#</td>
                                        <td>Points to be checked<sup>8</sup></td>
                                        <td colSpan={3}>Sales Team</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td className="index-col"><b>2.1</b></td>
                                        <td>Is customer and product information sufficient to perform evaluation?</td>
                                        <td className="check-col">
                                            <input type="radio" className={`${props.isValidFieldValue("reviewForm", "InformationSufficient") ? "" : "checkbox-is-invalid"}`} checked={props.getFieldValue("reviewForm", "InformationSufficient", "Yes")} onChange={e => props.setFieldValue("reviewForm", "InformationSufficient", "Yes", e.target.checked)} /> Yes
                                        </td>
                                        <td className="check-col">
                                            <input type="radio" className={`${props.isValidFieldValue("reviewForm", "InformationSufficient") ? "" : "checkbox-is-invalid"}`} checked={props.getFieldValue("reviewForm", "InformationSufficient", "No")} onChange={e => props.setFieldValue("reviewForm", "InformationSufficient", "No", e.target.checked)} /> No
                                        </td>
                                        <td>&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <td className="index-col"><b>2.2</b></td>
                                        <td>Is any known difference in understanding between the TÜV AUSTRIA and the client resolved? (Such as contract or certification agreement)</td>
                                        <td className="check-col">
                                            <input type="radio" className={`${props.isValidFieldValue("reviewForm", "KnownDifference") ? "" : "checkbox-is-invalid"}`} checked={props.getFieldValue("reviewForm", "KnownDifference", "Yes")} onChange={e => props.setFieldValue("reviewForm", "KnownDifference", "Yes", e.target.checked)} /> Yes
                                        </td>
                                        <td className="check-col">
                                            <input type="radio" className={`${props.isValidFieldValue("reviewForm", "KnownDifference") ? "" : "checkbox-is-invalid"}`} checked={props.getFieldValue("reviewForm", "KnownDifference", "No")} onChange={e => props.setFieldValue("reviewForm", "KnownDifference", "No", e.target.checked)} /> No
                                        </td>
                                        <td className="check-col">
                                            <input type="radio" className={`${props.isValidFieldValue("reviewForm", "KnownDifference") ? "" : "checkbox-is-invalid"}`} checked={props.getFieldValue("reviewForm", "KnownDifference", "N/A")} onChange={e => props.setFieldValue("reviewForm", "KnownDifference", "N/A", e.target.checked)} /> N/A
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="index-col"><b>2.3</b></td>
                                        <td>Is the scope of certification sought defined?</td>
                                        <td className="check-col">
                                            <input type="radio" className={`${props.isValidFieldValue("reviewForm", "ScopeSought") ? "" : "checkbox-is-invalid"}`} checked={props.getFieldValue("reviewForm", "ScopeSought", "Yes")} onChange={e => props.setFieldValue("reviewForm", "ScopeSought", "Yes", e.target.checked)} /> Yes
                                        </td>
                                        <td className="check-col">
                                            <input type="radio" className={`${props.isValidFieldValue("reviewForm", "ScopeSought") ? "" : "checkbox-is-invalid"}`} checked={props.getFieldValue("reviewForm", "ScopeSought", "No")} onChange={e => props.setFieldValue("reviewForm", "ScopeSought", "No", e.target.checked)} /> No
                                        </td>
                                        <td>&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <td className="index-col"><b>2.4</b></td>
                                        <td>Does the TASHA certification body have the competence and capability to perform the certification activity?</td>
                                        <td className="check-col">
                                            <input type="radio" className={`${props.isValidFieldValue("reviewForm", "CertificationActivity") ? "" : "checkbox-is-invalid"}`} checked={props.getFieldValue("reviewForm", "CertificationActivity", "Yes")} onChange={e => props.setFieldValue("reviewForm", "CertificationActivity", "Yes", e.target.checked)} /> Yes
                                        </td>
                                        <td className="check-col">
                                            <input type="radio" className={`${props.isValidFieldValue("reviewForm", "CertificationActivity") ? "" : "checkbox-is-invalid"}`} checked={props.getFieldValue("reviewForm", "CertificationActivity", "No")} onChange={e => props.setFieldValue("reviewForm", "CertificationActivity", "No", e.target.checked)} /> No
                                        </td>
                                        <td>&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <td className="index-col"><b>2.5</b></td>
                                        <td>Are the means available to perform all evaluation activities? Please check Records.</td>
                                        <td className="check-col">
                                            <input type="radio" className={`${props.isValidFieldValue("reviewForm", "EvaluationActivities") ? "" : "checkbox-is-invalid"}`} checked={props.getFieldValue("reviewForm", "EvaluationActivities", "Yes")} onChange={e => props.setFieldValue("reviewForm", "EvaluationActivities", "Yes", e.target.checked)} /> Yes
                                        </td>
                                        <td className="check-col">
                                            <input type="radio" className={`${props.isValidFieldValue("reviewForm", "EvaluationActivities") ? "" : "checkbox-is-invalid"}`} checked={props.getFieldValue("reviewForm", "EvaluationActivities", "No")} onChange={e => props.setFieldValue("reviewForm", "EvaluationActivities", "No", e.target.checked)} /> No
                                        </td>
                                        <td>&nbsp;</td>
                                    </tr>
                                </tbody>
                            </table>
                            <table className={`table-form ${isTableEditable() ? "" : "table-form-readonly"}`}>
                                <thead>
                                    <tr className="header">
                                        <td colSpan={5}>Result of Application Review</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td style={{width:"50%"}}>The Certification Application is acceptable?</td>
                                        <td style={{width:"25%"}}>
                                            <input type="radio" className={`${props.isValidFieldValue("reviewForm", "CertificationAcceptable") ? "" : "checkbox-is-invalid"}`} checked={props.getFieldValue("reviewForm", "CertificationAcceptable", "Yes")} onChange={e => props.setFieldValue("reviewForm", "CertificationAcceptable", "Yes", e.target.checked)} /> Yes
                                        </td>
                                        <td style={{width:"25%"}}>
                                            <input type="radio" className={`${props.isValidFieldValue("reviewForm", "CertificationAcceptable") ? "" : "checkbox-is-invalid"}`} checked={props.getFieldValue("reviewForm", "CertificationAcceptable", "No")} onChange={e => props.setFieldValue("reviewForm", "CertificationAcceptable", "No", e.target.checked)} /> No
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Name</td>
                                        <td>Signature</td>
                                        <td>Date</td>
                                    </tr>
                                    <tr>
                                        <td>{(props.fboState && props.fboState.reviewForm && props.fboState.reviewForm.signedByName) || ""}&nbsp;</td>
                                        <td>
                                            {props.fboState && props.fboState.reviewForm && props.fboState.reviewForm.signedBySignature &&
                                                <div>
                                                    <img className="img-fluid" style={{maxWidth:"100%", maxHeight: "100px", cursor: "pointer"}} src={`${api}Document/DownloadDocumentByName?fileName=${props.fboState.reviewForm.signedBySignature}`} alt="Not Found" />
                                                </div>
                                            }&nbsp;
                                        </td>
                                        <td>
                                            <MyDateRenderer value={(props.fboState && props.fboState.reviewForm && props.fboState.reviewForm.ticketForm && props.fboState.reviewForm.ticketForm.dateSigned) || ""} format={"dd.mm.yyyy"} />&nbsp;
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <table className="table-form table-form-alt">
                                <tbody>
                                    <tr>
                                        <td style={{width:"30%", paddingTop:10}}>------------------------------------------</td>
                                        <td style={{width:"30%"}}>&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <td colSpan={2}>
                                            <sup>1</sup> If it is Type5, please arrange for Saudi Q-Mark.
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan={2}>
                                            <sup>2</sup> Test report and factory audit report should be still valid to proceed Technical Review.
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan={2}>
                                            <sup>3</sup> Application review may be carried out by different appointed persons or simultaneously by the same person.
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan={2}>
                                            <sup>4</sup> If there is any missing file in the <b>“Records Check”</b> section, please connect with the client. This section will specifically look for the existence of a document. Detailed examination will be done in the evaluation section. Please forward the file with the relevant attachments as per each Technical Regulation to the operations department for evaluation.
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan={2}>
                                            <sup>5</sup> Quality Documents can be one of them as per CAI; EN ISO/IEC 17025 Test Report, PID (Product Identical Declaration), Type Certificates (SQM, IEC, GSO etc.) Other Certificates (CE, Bluesign, Oeko-Tex), In-house Test can be found in above link.
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan={2}>
                                            <sup>6</sup> Declaration of Conformity can be found in annexes of related Technical Regulation. It must be published by the client within their letterhead.
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan={2}>
                                            <sup>7</sup> Risk Assessment Form must be published by the client within their letterhead.
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan={2}>
                                            <sup>8</sup> If there is any missing information in <b>“Points to be Checked”</b> section, please connect with the client.
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <table className="table-form table-form-alt">
                                <tbody>
                                    <tr>
                                        <td colSpan={3}><hr/></td>
                                    </tr>
                                    <tr>
                                        <td style={{width:"25%", textAlign:"left"}}>Status: Approved</td>
                                        <td style={{width:"50%", textAlign:"center"}}>{getVersionName()}</td>
                                        <td style={{width:"25%", textAlign:"center"}}>Classification: Public</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </Row>
                </Collapse>
            </CardBody>
        </Card>
    );
};

export default FormReviewSASO;